import type { ErrorInfo, ReactElement, ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';
import { reportBoundaryError } from './reportBoundaryError';

interface ErrorBoundaryProps {
    children: ReactNode;
}

const handleError = (error: Error, errorInfo: ErrorInfo): void => {
    reportBoundaryError(error, errorInfo.componentStack);
};

// App-wide last resort (wraps everything but CITheme in index.tsx) — routes.tsx's errorElement catches in-route crashes first.
export const ErrorBoundary = ({ children }: ErrorBoundaryProps): ReactElement => (
    <ReactErrorBoundary FallbackComponent={ErrorBoundaryFallback} onError={handleError}>
        {children}
    </ReactErrorBoundary>
);
